import styled from "styled-components";
import { Link as LinkScroll } from "react-scroll";
import { FaTimes } from "react-icons/fa";
import colors from "../../styles/colors";

export const Container = styled.aside`
  position: fixed;
  z-index: 999;
  width: 100%;
  height: 100%;

  background: ${colors.azulEscuro};

  display: grid;
  align-items: center;

  top: 0;
  left: 0;

  transition: 0.3s ease-in-out;
  opacity: ${({ isOpen }) => (isOpen ? "100%" : "0")};
  top: ${({ isOpen }) => (isOpen ? "0" : "-100%")};
`;

export const CloseIcon = styled(FaTimes)`
  color: #535353;
`;

export const Icon = styled.div`
  position: absolute;
  top: 1.2rem;
  right: 1.5rem;

  background: transparent;
  font-size: 2rem;

  cursor: pointer;

  outline: none;
`;

export const Wrapper = styled.div`
  color: #535353;
`;

export const Link = styled(LinkScroll)`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  text-decoration: none;

  list-style: none;
  transition: 0.2s ease-in-out;
  color: #535353;

  cursor: pointer;

  &:hover {
    color: ${colors.vermelho};
    transition: 0.2s ease-in-out;
  }
`;
export const Menu = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(6, 80px);
  text-align: center;

  @media screen and (max-width: 480px) {
    grid-template-rows: repeat(6, 60px);
  }
`;
